module.exports = __webpack_public_path__ + "img/expert_avatar_2.38e66354.png";